import React, { Component, Fragment } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Form } from "react-bootstrap";
import { jsPDF } from "jspdf";

//import components
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";

//import Action
import { getUserBalnce } from "../../actions/userActions";

// import library
import { firstLetterCase } from "../../lib/capitalize";

class Userbalance extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        key: "userId.email",
        text: "Email",
        className: "userId",
        align: "left",
        sortable: true,
        cell: (record) => {
          return record.userId && record.userId.email ? record.userId.email:"-";
        },
      },
      {
        key: "userId.phoneNo",
        text: "Phone No",
        className: "userId",
        align: "left",
        sortable: true,
        cell: (record) => {
          return record.userId && record.userId.phoneNo ? `+${record.userId.phoneCode}${record.userId.phoneNo}`:"-";
        },
      },
      {
        key: "currency.currencySymbol",
        text: "Currency",
        className: "currency",
        align: "left",
        sortable: true,
        cell: (record) => {
          return record.currency && record.currency.currencySymbol ? record.currency.currencySymbol:"-";
        },
      },

      {
        key: "spotwallet",
        text: "Spot Wallet",
        className: "balance",
        align: "left",
        sortable: true,
        cell: (record) => {
          return record.spotwallet > 0 ? record.spotwallet : 0;
        },
      },
      {
        key: "p2pbalance",
        text: "P2P Wallet",
        className: "derivativeWallet",
        align: "left",
        sortable: true,
        cell: (record) => {
          return record.p2pbalance > 0 ? record.p2pbalance : 0;
        },
      },
    ];

    this.state = {
      records: [],
      totalCount: 0,
      offset: 0,
      pageSize: 10,
      sortOrder: {
        column: "_id",
        order: "desc",
      },
      loading: true,
      exportType: "current",
      extraButtons: [{
        className: "btn btn-primary buttons-pdf",
        title: "Export PDF",
        children: [
          <span>
            <i className="glyphicon glyphicon-print fa fa-file-pdf-o" aria-hidden="true"></i>
          </span>,
        ],
        onClick: (event) => {
          this.exportPDF();
        },
      },
      {
        className: "btn btn-primary buttons-csv",
        title: "Export CSV",
        children: [
          <span>
            <i className="glyphicon glyphicon-print fa fa-file-excel-o" aria-hidden="true"></i>
          </span>
        ],
        onClick: (event) => {
          this.exportCSV();
        },
      }]
    };

    this.config = {
      page_size: this.state.limit,
      sort: this.state.sortOrder,
      length_menu: [10, 20, 50],
      no_data_text: "No user balance found!",
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      key_column: "_id",
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      pagination: "advance",
      show_info: true,
      button: {
        extra: true,
      }
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData = async (filter = "") => {
    try {
      let data = {
        sortOrder:this.state.sortOrder,
        filter,
        limit: this.state.pageSize,
        offset: this.state.offset,
      };
      let { status, totalCount, result } = await getUserBalnce(data);
      if (status) {
        this.setState({ loading: false });
        this.setState({ records: result, totalCount });
      }
    } catch (e) {}
  }

  search = data => {
    let filter = data.filter_value;
    let pageSize = data.page_size;
    let offset = (data.page_number-1)*pageSize;
    let sortOrder = data.sort_order ? data.sort_order:this.state.sortOrder;
    this.setState({ records: [], offset, pageSize, sortOrder, filter, loading: true }, function() {
      this.getData(filter);
    });  
  }

  exportCSV = async () => {

    let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let data = {
      timezone,
      sortOrder,
      filter,
      limit: exportType == "current" ? pageSize:totalCount,
      offset: exportType == "current" ? offset:0,
      download: 1
    };

    this.setState((prevState) => {
      let extraButtons = [...prevState.extraButtons];
      extraButtons[1].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
      return { extraButtons };
    });


    let { status, result } = await getUserBalnce(data);

    this.setState((prevState) => {
      let extraButtons = [...prevState.extraButtons];
      extraButtons[1].children = [
        <span><i className="glyphicon glyphicon-print fa fa-file-excel-o" aria-hidden="true"></i></span>
      ];
      return { extraButtons };
    });

    let records = status ? result: [];
    let separator = ";";
    let headers = [
      "Email",
      "Phone No",
      "Currency",
      "Spot Wallet",
      "P2P Wallet",
    ];

    let rows = [];
    records.length > 0 && records.map((elt) => rows.push({
      "Email": elt.userId && elt.userId.email ? elt.userId.email:"-",
      "Phone No": elt.userId && elt.userId.phoneNo ? `+${elt.userId.phoneCode}${elt.userId.phoneNo}` : "-",
      "Currency": elt.currency && elt.currency.currencySymbol ? elt.currency.currencySymbol:"-",
      "Spot Wallet": elt.spotwallet > 0 ? elt.spotwallet : 0,
      "P2P Wallet": elt.p2pbalance > 0 ? elt.p2pbalance : 0,
    }));

    let csvContent = `${headers.join(separator)}\n${rows.map((row) =>
      headers.map((k) => {
        let cell = row[k] === null || row[k] === undefined ? "" : row[k];

        cell = cell instanceof Date ? cell.toLocaleString():cell.toString().replace(/"/g, '""');

        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator)
    ).join("\n")}`;

    let title = "Wallet Balance";
    let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
          // In case of IE 10+
      navigator.msSaveBlob(blob, title);
    } else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
              // Browsers that support HTML5 download attribute
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", title);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  exportPDF = async () => {

    let { sortOrder, filter, pageSize, offset, totalCount, exportType } = this.state;
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let data = {
      timezone,
      sortOrder,
      filter,
      limit: exportType == "current" ? pageSize:totalCount,
      offset: exportType == "current" ? offset:0,
      download: 1
    };

    this.setState((prevState) => {
      let extraButtons = [...prevState.extraButtons];
      extraButtons[0].children = [<span><i className="fa fa-spinner fa-spin" aria-hidden="true"></i></span>];
      return { extraButtons };
    });


    let { status, result } = await getUserBalnce(data);

    this.setState((prevState) => {
      let extraButtons = [...prevState.extraButtons];
      extraButtons[0].children = [
        <span><i className="glyphicon glyphicon-print fa fa-file-pdf-o" aria-hidden="true"></i></span>
      ];
      return { extraButtons };
    });

    let records = status ? result: [];

    let unit = "pt";
    let size = "A4"; // Use A1, A2, A3 or A4
    let orientation = "landscape"; // portrait or landscape

    let marginLeft = 40;
    let doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(13);

    let title = "Wallet Balance";
    let headers = [[
      "Email",
      "Phone No",
      "Currency",
      "Spot Wallet",
      "P2P Wallet",
    ]];

    let downloadData = records.length > 0 && records.map((elt) => [
      elt.userId && elt.userId.email ? elt.userId.email:"-",
      elt.userId && elt.userId.phoneNo ? `+${elt.userId.phoneCode}${elt.userId.phoneNo}` : "-",
      elt.currency && elt.currency.currencySymbol ? elt.currency.currencySymbol:"-",
      elt.spotwallet > 0 ? elt.spotwallet : 0,
      elt.p2pbalance > 0 ? elt.p2pbalance : 0,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: downloadData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Wallet Balance.pdf");
  }

  render() {
    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar menuKey={this.props.menuKey} />
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <div className="float-xl-right">
                Export
                {["current", "all"].map((v) => (
                  <Form.Check
                    inline
                    type="radio"
                    name="exportType"
                    value={v}
                    key={v}
                    onChange={(e) => this.setState({ exportType: e.target.value })}
                    defaultChecked={v == this.state.exportType}
                    label={firstLetterCase(v)}
                  />
                ))}
              </div>
              <h3 className="mt-2 text-secondary">Wallet Balance List</h3>
              <ReactDatatable
                config={this.config}
                records={this.state.records}
                columns={this.columns}
                dynamic={true}
                total_record={this.state.totalCount}
                loading={this.state.loading}
                onChange={this.search}
                extraButtons={this.state.extraButtons}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Userbalance;
